'use strict';

import {getSelectedCompanyForUser, popupCenterDual} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnVouchersEarlierReleasesActions = function () {

    var tableName = '#datatable-vouchers-earlier-releases';
    var table = $(tableName).DataTable();

    if (!element_exists(tableName)) return;

    $('#form-vouchers-earlier-releases').off('submit')
        .on('submit', function (e) {
            e.preventDefault();

            const companyId = getSelectedCompanyForUser();
            const url = '/vouchers-earlier-releases/load-table/' + companyId;

            const table = $(tableName);
            table.DataTable().clear();
            table.DataTable().ajax.url(url);

            table.DataTable().ajax.url(url).load(function () {
                setTimeout(function () {
                    $(tableName).parent('.dataTables_scrollBody').css('width', '100%');
                }, 500);
            });
        });

    /*Avoid loading handler twice or more*/
    $(document).off('click', '.btn-display-earlier-voucher');
    $(document).on('click', '.btn-display-earlier-voucher', function (e) {
        e.preventDefault();

        let rowData = table.row($(this).parents('tr')).data();
        var data = rowData !== undefined ? rowData : {};

        popupCenterDual('voucher/file/' + data.id, data.Text, window.innerWidth / 3, window.innerHeight / 1.5);
    });
};